import { Component, Mixins } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import { State } from 'vuex-class';
import AppUploadDocumentenVue from '@/components/upload-documenten/AppUploadDocumenten.vue';

@Component({
  components: {
    'app-upload-documenten': AppUploadDocumentenVue
  }
})
export default class AppRekeningnummer extends Mixins(AppHypotheekMixin) {
  @State(state => state.config.ppfMachtigingIncassoUrl)
  public ppfMachtigingIncassoUrl!: string;

  public get uploadUrl(): string {
    return `Formulieren/WijzigingRekeningnummer/${this.hypotheeknummer}`;
  }

  public uploadSucceeded() {
    this.$router.push({ name: 'wijzigen', params: { uploadRekeningnummerSucceeded: 'true' } });
  }
}
